import React, { useState } from 'react';


export default function TextForm(props) {
    
    const handleReset = () => {
        let newText = '';
        setText(newText);
        props.showAlert("Text Box has been cleared!", "success");
    }
    const handleUpClick = () => {
        // console.log("UpperCase was clicked" + text);
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to UpperCase!", "success");
    }
    const handleLowClick = () => {
        // console.log("UpperCase was clicked" + text);
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to LowerCase!", "success");
    }
    const handleCopy = () => {
        navigator.clipboard.writeText(text);
        props.showAlert("Text has been copied!", "success");
    }
    const handleExtraSpace = () => {
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));
        props.showAlert("Extra Spaces has been removed!", "success");
    }
    const handleOnChange = (event) => {
        // console.log("On Change");
        setText(event.target.value);
    }
    const [text, setText] = useState('Enter text here');
    return (
        <>
            <div className="container my-5">
                <h1>{props.heading}</h1>
                <div className="mb-3">
                    <textarea className="form-control" value={text} onChange={handleOnChange} id="myBox" rows="10"></textarea>
                </div>
                <button disabled={text.length===0} type="button" className="btn btn-primary my-2 me-3" onClick={handleReset}>Reset</button>
                <button disabled={text.length===0} type="button" className="btn btn-primary my-2 me-3" onClick={handleUpClick}>Convert to Uppercase</button>
                <button disabled={text.length===0} type="button" className="btn btn-primary my-2 me-3" onClick={handleLowClick}>Convert to Lowercase</button>
                <button disabled={text.length===0} type="button" className="btn btn-primary my-2 me-3" onClick={handleCopy}>Copy Text</button>
                <button disabled={text.length===0} type="button" className="btn btn-primary my-2 me-3" onClick={handleExtraSpace}>Remove Extra Spaces</button>
            </div>
            <div className="container mb-5">
                <h2>Your Text Summary</h2>
                <p>{text.split(/\s+/).filter((element) => {return element.length!==0}).length} words and {text.length} characters</p>
                <p>{0.008 * text.split(" ").length} minutes to read</p>
                <h3>Preview</h3>
                <p>{text.length>0?text:"Enter Something in the TextBox to preview"}</p>
            </div>
        </>
    )
}
